class EventForm {
  id:string;
  complete:boolean = false
  caseId:string; 
  caseEventId:string;
  eventFormDefinitionId:string;
  formResponseId:string;
  constructor() {

  }
}

export { EventForm }